import VueInputAutowidth from 'vue-input-autowidth'
import { defineNuxtPlugin } from 'nuxt/app'

export default defineNuxtPlugin((app) => {
  app.vueApp.use(VueInputAutowidth)
})
